/**
 * Procedure Categories and Procedures for Diploma in Radiation Medicine students
 * Extracted with strict evidence from official NMC PDF
 */
export const RADIATION_MEDICINE_PROCEDURES = {
  "In-Vivo Nuclear Diagnostic Procedures": [
    "Esophageal Transit Time Measurement",
    "Gastric Emptying Time Study",
    "Renal Transplant Evaluation Study",
    "Ejection Fraction (EF) and Regional Wall Motion Abnormality (RWMA) Determination",
  ],
  "In-Vitro Nuclear Diagnostic Procedures": [
    "Glomerular Filtration Rate (GFR) Estimation",
    "Red Cell Survival Study",
    "Plasma and Blood Volume Estimation",
    "C-14 Urea Breath Test",
    "Radioactive Iodine Uptake (RAIU) and Perchlorate Discharge Test",
    "Schilling Test",
  ],
  "Therapeutic Nuclear Procedures": [
    "Radioiodine Therapy (for Hyperthyroidism and Thyroid Cancer)",
    "Radionuclide Bone Pain Palliation Therapy (P32, Sr89, Sm153, Lu177)",
    "Radiosynovectomy",
    "Radiopeptide & Radioconjugate Therapy",
    "Radioimmunotherapy",
  ],
};

export const RADIATION_MEDICINE_CATEGORIES = Object.keys(RADIATION_MEDICINE_PROCEDURES);

export const isDiplomaInRadiationMedicineDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    (d.includes("radiation medicine") ||
    d.includes("nuclear medicine")) &&
    !(d.includes("md") || d.includes("master of medicine"))
  );
};
